/**
 * Should entering a caption turn the block's "Show captions" on by itself?
 *
 * QA-63 (Kelly, 2026-08-03): she typed "Elephant in the wild" into the carousel's
 * caption editor, saved, and nothing appeared on the slide — because "Show
 * captions" defaults OFF (the DL-041 deck default). Nothing was broken; the
 * default simply swallowed her intent without saying so.
 *
 * DECISION — Gordon, 2026-08-03: **auto-ON when captioned.** The DL-041 default
 * stays OFF, so uncaptioned media is untouched and the deck spec holds. But
 * typing a caption IS the statement of intent, so the first non-empty caption on
 * a block switches its captions on.
 *
 * Two things this deliberately does NOT do:
 *   * It never turns captions back OFF. Clearing a caption is not a request to
 *     hide the other slides' captions, and a control that silently un-sets
 *     itself is worse than one that never moved.
 *   * It never fires when captions are already on, so it cannot fight a user who
 *     turned them on (or off and back on) by hand.
 *
 * @param {string|null|undefined} nextTitle    the caption just entered
 * @param {boolean|null|undefined} showCaptions the block's current toggle state
 * @returns {boolean} true only when this entry should flip the toggle on
 */
export function shouldAutoEnableCaptions(nextTitle, showCaptions) {
  if (showCaptions) return false;
  return String(nextTitle ?? "").trim().length > 0;
}

export default shouldAutoEnableCaptions;
